import { css, cx, useTheme } from '@fable/theme'
import { usePreloadImage } from '@fable/hooks'

interface Props {
  className?: string
  cover: string
}

export const StreakCalendarBookCover = ({ className = '', cover }: Props) => {
  const { colors } = useTheme()
  const img = usePreloadImage(cover, 100)
  const color = colors.uiPearlUltraLight

  if (!img?.src.length) return null

  const imgSrc = `${img?.src}&mode=cors`
  const altTag = 'streak book cover'

  return (
    <img
      src={imgSrc}
      alt={altTag}
      className={cx(
        css`
          display: block;
          width: 20px;
          height: 28px;
          object-fit: cover;
          object-position: center;
          border-radius: 2px;
          border: 1px solid ${color};
          background-color: ${color};
          overflow: hidden;
        `,
        className
      )}
    />
  )
}
